import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import closeButton from "../../assets/svg/close.svg";
import Button from "../../components/Button/Button";
import Footer from "../../components/Footer/Footer";
import useWindowSize from "../../utils/useWindowSize";
import LowerNavBar from "../NavBar/LowerNavBar";
import TreeMeun from "../TreeMeun/TreeMeun";
import style from "./Booklist.module.css";

const treeData = [
  {
    id: 1,
    category: "分類名稱",
    books: [
      { bookname: "book1" },
      { bookname: "book2" },
      { bookname: "book3" },
    ],
  },
  {
    id: 2,
    category: "分類名稱",
    books: [
      { id: 1, bookname: "book1" },
      { bookname: "book2" },
      { bookname: "book3" },
      { bookname: "book3" },
      { bookname: "book3" },
      { bookname: "book3" },
      { bookname: "book3" },
    ],
  },
  {
    id: 3,
    category: "分類名稱",
    books: [
      { bookname: "book1" },
      { bookname: "book2" },
      { bookname: "book3" },
    ],
  },
  {
    id: 4,
    category: "分類名稱",
    books: [
      { bookname: "book1" },
      { bookname: "book2" },
      { bookname: "book3" },
    ],
  },
  {
    id: 5,
    category: "分類名稱",
    books: [
      { bookname: "book1" },
      { bookname: "book2" },
      { bookname: "book3" },
      { bookname: "book3" },
      { bookname: "book3" },
      { bookname: "book3" },
      { bookname: "book3" },
    ],
  },
  {
    id: 6,
    category: "分類名稱",
    books: [
      { bookname: "book1" },
      { bookname: "book2" },
      { bookname: "book3" },
    ],
  },
  {
    id: 7,
    category: "分類名稱",
    books: [
      { bookname: "book1" },
      { bookname: "book2" },
      { bookname: "book3" },
    ],
  },
  {
    id: 8,
    category: "分類名稱",
    books: [
      { bookname: "book1" },
      { bookname: "book2" },
      { bookname: "book3" },
      { bookname: "book3" },
      { bookname: "book3" },
      { bookname: "book3" },
      { bookname: "book3" },
    ],
  },
  {
    id: 9,
    category: "分類名稱",
    books: [
      { bookname: "book1" },
      { bookname: "book2" },
      { bookname: "book3" },
    ],
  },
];

export default function Booklist() {
  const { width, height } = useWindowSize();
  const { i18n } = useTranslation();
  const [needLoad, setNeedLoad] = useState(false);

  useEffect(() => {
    // 每次進入頁面帶時間戳，避免瀏覽器/CDN 緩存舊書單
    const cacheBust = Date.now();

    // 載入外部 CSS
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `https://suep.3201cn.com/nowbook/src/css/booklist.css?t=${cacheBust}`;
    link.id = 'booklist-css'; // 給一個 ID 方便後續移除
    document.head.appendChild(link);

    // 載入外部 JavaScript
    const script = document.createElement('script');
    script.src = `https://suep.3201cn.com/nowbook/static/js/booklist.js?t=${cacheBust}`;
    script.id = 'booklist-js';
    script.async = true;
    document.head.appendChild(script);

    // 清理函數：當離開這個頁面時移除
    return () => {
      const linkElement = document.getElementById('booklist-css');
      const scriptElement = document.getElementById('booklist-js');
      
      if (linkElement) {
        document.head.removeChild(linkElement);
      }
      if (scriptElement) {
        document.head.removeChild(scriptElement);
      }
    };
  }, []); // 空依賴陣列，只在組件掛載時執行一次

  return (
    <>
      <LowerNavBar />

      <div className={style.mainLayoutContainer}>
        <div className={style.mainContainer}>
          <div className={style.floatingSidebar}>
            <div className={style.floatingSidebarHeader}>
              <div className={style.closeButton}>
                <img src={closeButton} />
                <Button
                  styleType={"upperNavbarButton"}
                  callBack={() => console.log(1)}
                >
                  <Trans>close</Trans>
                </Button>
              </div>
            </div>
            {treeData.map((item, idx) => (
              <TreeMeun props={item} key={idx} />
            ))}
          </div>
          <div
            className={
              width <= 768
                ? style.mainLayoutInnerContainer2
                : style.mainLayoutInnerContainer
            }
          >
            <div className="downbook-wrap">
              <div className="fl bookNav"></div>
              <div className="downbook-content"></div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
